import { type FC, type JSX } from 'react';
import { Box, Collapse, Flex, Link, Text, VStack } from '@chakra-ui/react';
import { CloseIcon, ExternalLinkIcon } from '@chakra-ui/icons';
import { first } from 'lodash';
import JobTypeSelector from './JobTypeSelector';
import TripTypeDropDown from './TripTypeDropDown';
import { useTripsContext } from '../../GlobalContextProvider/GlobalContextProvider';
import { ReactComponent as ChevronUpIcon } from '../../../assets/svg/UpArrow.svg';
import { ReactComponent as ChevronDownIcon } from '../../../assets/svg/DownArrow.svg';
import { defaultFilters } from '../../GlobalContextProvider/initial-trips-state';
import { type Page } from '../../../types';
import { translate } from '../../../constants/translation';
import { externalLinks } from '../../../constants/constants';

interface Props {
  displayMoreFilters: boolean;
  toggleMoreFilters: () => void;
  onClose: () => void;
  page: Page;
  selectedDate: Date;
  resetFilters: () => void;
}

const TripsPanelHeaderSection: FC<Props> = ({
  displayMoreFilters,
  toggleMoreFilters,
  onClose,
  page,
  selectedDate,
  resetFilters,
}) => {
  const { tripType, jobType, vesselName } = useTripsContext();

  const anyFilterApplied =
    first(tripType) !== first(defaultFilters.tripType) ||
    jobType !== defaultFilters.jobType ||
    vesselName !== defaultFilters.vesselName ||
    !!selectedDate;

  const isExpanded = (): boolean => {
    return displayMoreFilters;
  };

  const renderChevronIcon = (): JSX.Element => {
    return isExpanded() ? <ChevronUpIcon /> : <ChevronDownIcon />;
  };

  return (
    <VStack className="trips-panel-header-container">
      <Flex className="header-section" justifyContent="space-between">
        <Text className="text-header" alignContent="center">
          {translate('TRIPS_PANEL_HEADING')}
        </Text>
        <CloseIcon style={{ cursor: 'pointer', alignSelf: 'center' }} onClick={onClose} />
      </Flex>
      <Box className="more-filters-container">
        <Flex justifyContent="space-between" className="text-sm-medium">
          <Link href={externalLinks.aimFor8Report} target="_blank">
            {translate('PERFORMANCE_DETAILS')}
            <ExternalLinkIcon />
          </Link>
          <Flex justifyContent="flex-end">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link onClick={toggleMoreFilters}>
              {renderChevronIcon()}
              {translate('FILTERS')}
            </Link>
            {anyFilterApplied ? (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <Link onClick={resetFilters} marginLeft="20px">
                {translate('CLEAR_ALL')}
              </Link>
            ) : (
              <></>
            )}
          </Flex>
        </Flex>
        <Collapse in={displayMoreFilters} animateOpacity>
          <Box width="100%">
            <JobTypeSelector page={page} />
            <TripTypeDropDown page={page} />
          </Box>
        </Collapse>
      </Box>
    </VStack>
  );
};

export default TripsPanelHeaderSection;
